export default __webpack_public_path__ + "static/media/right7.8bacf066.png";